module.exports = __webpack_public_path__ + "static/media/testimonial-image.c4b256d0.jpg";